import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { configureApi } from "./app/configure-api";
import "./i18n";
import "./styles/index.css";

// Wire the transport layer before the first render so no request can escape unauthenticated.
configureApi();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root was not found in index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
